export default "__VITE_ASSET__BGpp8Cz9__"